export default __webpack_public_path__ + "3ca525a568f97df25d6b4bc1e0cbcea8.svg";